import React, { useState } from 'react';
import openIcon from '../../assets/icons/openArrow.svg';
import closeIcon from '../../assets/icons/closeArrow.svg';
import styles from './CollapseCardV2.module.scss';
interface CollapseProps {
  children: React.ReactNode;
  title: string;
  isToggleOpen?: boolean;
}

const Collapse: React.FC<CollapseProps> = ({ children, isToggleOpen, title }) => {
  const [isOpen, setIsOpen] = useState<boolean>(isToggleOpen ?? false);
  const toggleSwitch = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div onClick={toggleSwitch} className={styles.collapseContainer}>
        <p className={styles.groupName}>{title}</p>
        <img src={isOpen ? openIcon : closeIcon} alt="open-icon" />
      </div>
      {isOpen && <div>{children}</div>}
    </div>
  );
};

export default Collapse;
